export default __webpack_public_path__ + "static/media/logo.dfcebdf7.svg";